import React, { useMemo, useState } from "react";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { Box, Paper, Typography, MenuItem } from "@mui/material";
import { getAssemblyUser } from "../../apis/user.api";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import CustomInput from "../../components/inputs/CustomInput";
import { closeModal } from "../../store/actions/modalAction";
import SubmitButton from "../../components/button/SubmitButton";
import { updateOrderApi } from "../../apis/patient.api";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { callApiAction } from "../../store/actions/commonAction";

const AssignOrderController = ({ status, order_ID, callBack }) => {
  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const [fields, setFields] = useState({
    err: "",
    assigned_to: "",
    status: status || "",
    id: order_ID,
  });

  const valiateAssemblyMember = useMemo(
    () => [
      { required: true, value: fields.assigned_to, field: "Assembly Member" },
    ],
    [fields]
  );

  const onAssignBtnClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    const validationResponse = validate(valiateAssemblyMember);
    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await updateOrderApi({ ...fields }),
          async (response) => {
            const data = {
              order_status: response?.status,
              isAssigned: response?.isAssigned,
            };
            await callBack(data);
            setLoading(false);

            dispatch(
              callSnackBar("Assigned Successfully", SNACK_BAR_VARIETNS.success)
            );
            dispatch(closeModal("AssignInformation"));
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          }
        )
      );
    } else {
      setFields((prevFields) => ({ ...prevFields, err: validationResponse }));
      setLoading(false);
    }
  };

  return (
    <CustomDialog id={"AssignInformation"} title={"Assign"}>
      <Box>
        <Paper
          elevation={0}
          sx={{ width: "100%", minHeight: "100%", padding: 5, mt: 2 }}
        >
          <Box>
            <Typography color="error">{fields.err}</Typography>
          </Box>
          <AsyncDropDown
            OptionComponent={({ option, ...rest }) => {
              return <MenuItem {...rest}>{option?.name}</MenuItem>;
            }}
            InputComponent={(props) => (
              <CustomInput
                placeholder
                label="Select Assembly Member"
                {...props}
              />
            )}
            lazyFun={async (filters) => {
              return await getAssemblyUser({ ...filters });
            }}
            label="Select Assembly Member*"
            onChange={async (changedVal) => {
              setFields({ ...fields, err: "", assigned_to: changedVal?._id });
            }}
            titleKey={"name"}
            valueKey={"_id"}
          />

          <SubmitButton
            sx={{ mt: 5, width: "100%" }}
            onClick={onAssignBtnClick}
            title={"Assign"}
            loading={loading}
          />
        </Paper>
      </Box>
    </CustomDialog>
  );
};

export default AssignOrderController;
